module.exports = __webpack_public_path__ + "img/1.4d958776.png";